module.exports = __webpack_public_path__ + "static/media/adopting-user3.f524f508.png";